import React from "react";
// javascipt plugin for creating charts
import { Chart, registerables } from "chart.js";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components

// core components
import boxShadows from "assets/theme/box-shadow.js";
import { chartExample1 } from "variables/charts.js";

Chart.register(...registerables);

function CardSalesValue() {
  const theme = useTheme();
  const [activeNav, setActiveNav] = React.useState(1);
  const [chartExample1Data, setChartExample1Data] = React.useState("data1");

  const toggleNavs = (index) => {
    setActiveNav(index);
    setChartExample1Data("data" + index);
  };
  return (
    <>
      <Card
        sx={{
          background:
            "linear-gradient(87deg," +
            theme.palette.dark.main +
            ",#1a174d)!important",
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
      >
        <CardHeader
          subheader={
            <Grid
              container
              component={Box}
              sx={{ alignItems: "center", justifyContent: "space-between" }}
            >
              <Grid item xs="auto">
                <Box
                  component={Typography}
                  variant="h6"
                  sx={{
                    letterSpacing: ".0625rem",
                    marginBottom: ".25rem!important",
                    textTransform: "uppercase",
                  }}
                >
                  <Box component="span" sx={{ color: theme.palette.gray[400] }}>
                    Overview
                  </Box>
                </Box>
                <Box
                  component={Typography}
                  variant="h2"
                  sx={{ marginBottom: "0!important" }}
                >
                  <Box
                    component="span"
                    sx={{ color: theme.palette.white.main }}
                  >
                    Sales value
                  </Box>
                </Box>
              </Grid>
              <Grid item xs="auto">
                <Box
                  sx={{
                    justifyContent: "flex-end",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant={activeNav === 1 ? "contained" : "neutral"}
                    color="primary"
                    component={Box}
                    sx={{ marginRight: "1rem!important" }}
                    onClick={() => toggleNavs(1)}
                  >
                    Month
                  </Button>
                  <Button
                    variant={activeNav === 2 ? "contained" : "neutral"}
                    color="primary"
                    onClick={() => toggleNavs(2)}
                  >
                    Week
                  </Button>
                </Box>
              </Grid>
            </Grid>
          }
          sx={{ backgroundColor: "initial!important" }}
        ></CardHeader>
        <CardContent>
          <Box sx={{ position: "relative", height: "440px" }}>
            <Line
              data={chartExample1[chartExample1Data]}
              options={chartExample1.options}
              getDatasetAtEvent={(e) => console.log(e)}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

export default CardSalesValue;
